import React from "react"
import i18n from "i18n"
import useTemplatesManager from "hooks/templates/useTemplatesManager"
import { PLANHOPPER_ORG_ID } from "constants/common"
import { Box, Grid, Typography } from "@mui/material"
import TemplateCard from "./TemplateCard"
import ConfirmationModal from "common/ConfirmationModal"
import Loading from "common/Loading"
import SingleTextInputModal from "common/SingleTextInputModal"

const MyTemplatesTab = () => {
  const {
    state,
    duplicateFromTemplate,
    duplicateToTemplate,
    deleteTemplate,
    confirmDelete,
    openEditTemplate,
    closeEditTemplate,
    updateTemplateName,
  } = useTemplatesManager()

  const templates = (state.templates || []).filter(
    template => template.organizationId !== PLANHOPPER_ORG_ID,
  )

  const getTemplateActions = (projectId, organizationId) => [
    {
      key: "delete",
      label: i18n.t("Eliminar"),
      onClick: () => confirmDelete(true, projectId, organizationId),
    },
    {
      key: "edit",
      label: i18n.t("Editar"),
      onClick: () => {
        openEditTemplate(true, projectId, organizationId)
      },
    },
    {
      key: "duplicate",
      label: i18n.t("templates.actions.duplicateProject"),
      onClick: () => duplicateFromTemplate(projectId, organizationId),
    },
    {
      key: "duplicate_plantilla",
      label: i18n.t("templates.actions.duplicateAsTemplate"),
      onClick: () => duplicateToTemplate(projectId, organizationId),
    },
  ]

  if (state.loading) {
    return <Loading />
  }

  return (
    <Grid container spacing={3}>
      {templates.length === 0 ? (
        <Box sx={{ p: 4 }}>
          <Typography variant="body1">{i18n.t("templates.empty")}</Typography>
        </Box>
      ) : (
        templates.map(({ projectId, name, projectImage, organizationId }) => (
          <Grid item key={projectId} xs={12} sm={6} md={4} lg={3}>
            <TemplateCard
              title={name}
              linkTo={`/bancodeprecios/templateV2/${projectId}`}
              imageSrc={projectImage}
              actions={getTemplateActions(projectId, organizationId)}
            />
          </Grid>
        ))
      )}

      <SingleTextInputModal
        open={state.editTemplate.open}
        setOpen={_open => closeEditTemplate()}
        title={i18n.t("templates.modals.editProject")}
        btnSubmitLabel={i18n.t("buttons.save")}
        btnCancelLabel={i18n.t("buttons.cancel")}
        fnSubmit={newValue => {
          updateTemplateName(
            newValue,
            state.editTemplate.template.projectId,
            state.editTemplate.template.organizationId,
          )
        }}
        fnCancel={() => closeEditTemplate()}
        initialValue={state.editTemplate.template?.name}
      />

      <ConfirmationModal
        open={state.deleteTemplate.open}
        onClose={() => confirmDelete(false, null, null)}
        onConfirm={() =>
          deleteTemplate(
            state.deleteTemplate.template.projectId,
            state.deleteTemplate.template.organizationId,
          )
        }
        title={i18n.t("certHistory.confirmationModal.title")}
        message={i18n.t("certHistory.confirmationModal.message")}
        confirmButtonText={i18n.t("buttons.confirm")}
        cancelButtonText={i18n.t("buttons.cancel")}
      />
    </Grid>
  )
}

export default MyTemplatesTab
